import React from "react";
import Lottie from "lottie-react";
import animationData from "./img/smartphone-call.json"; // ملف JSON للأنيميشن

export default function MyAnimation() {
  return (
    <div className="w-1/2 max-w-xs fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
      <Lottie
        animationData={animationData}
        loop={true}
        className="w-full h-auto  group-hover:hidden"
      />
    </div>
  );
}
